// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__37MWB","content":"ManualTimeModal_content__2Hbyw"};